// for publisher/components/entities/Body.js

import { CommonBlogPostBody } from 'common/components/entities/blog-post-body'
import { BodyInterface } from 'common/types/entities/body-interface'
import ChildrenEntities from 'publisher/components/ChildrenEntities'
import { useBackgroundImage } from 'publisher/hooks/useBackgroundImage'
import React from 'react'
import { BackgroundUi } from './ui/background-ui'

interface BodyProps {
  entity: BodyInterface
}

export const BlogPostBody = ({ entity }: BodyProps) => {
  const {
    childIds,
    background,
    backgroundColor,
    mobileBackgroundColor,
    blur,
    mobileBackground,
  } = entity

  const { backgroundImage, mobileBackgroundImage } = useBackgroundImage({
    backgroundFileId: entity.backgroundFileId,
    mobileBackgroundFileId: entity.mobileBackgroundFileId,
  })

  return (
    <CommonBlogPostBody
      background={background}
      backgroundImage={backgroundImage}
      backgroundColor={backgroundColor}
      blur={blur ?? 0}
      mobileBackground={mobileBackground}
      mobileBackgroundImage={mobileBackgroundImage}
      mobileBackgroundColor={mobileBackgroundColor}
      styles={BackgroundUi}
    >
      <ChildrenEntities childIds={childIds as string[]} />
    </CommonBlogPostBody>
  )
}
